import React, { FC } from 'react'
import { Page } from '../../components/Layouts/Index'
import Banner from '../../components/Banner';


const Home: FC = () => {
  return (
    <Page>
      <Banner />
    </Page>
  )
}

export default Home
